import { render, staticRenderFns } from "./RocketChat.vue?vue&type=template&id=30738d8e"
import script from "./RocketChat.vue?vue&type=script&lang=js"
export * from "./RocketChat.vue?vue&type=script&lang=js"
import style0 from "./RocketChat.vue?vue&type=style&index=0&id=30738d8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports